export default __webpack_public_path__ + "static/media/milestone 3600.ac872a6b.svg";